import '../App.css';


function Home() {
  return (
    <div className="main"><h1>Hello from Home</h1></div>
  );
};

export default Home;
